import Warning from './Warning';
import Error from './Error';
import Success from './Success';
import Info from './Info';

export default {
  Warning,
  Error,
  Success,
  Info,
};

export const WarningInpage = Warning;
export const ErrorInpage = Error;
export const SuccessInpage = Success;
export const InfoInpage = Info;
